
<style lang="less" scoped>
*{list-style: none;}
body {margin: 0 !important;}
.box{width: 100%;height: 100vh;background: rgba(238,238,238);}
#sceneview {position: absolute;width: 100%;height: 100%;}
.search{display: flex; justify-content:space-between;padding: 0 10px; position: absolute;top: 15px;left: 20px;width: 342px;height: 60px;background: rgba(10, 17, 43, 0.4); border-radius: 30px;}
.heading{margin-left:20px;color:#fff;display: flex;justify-content: center;flex-direction: column;}
.menu{position: absolute;bottom: 8px; left: 20px; top: 86px; height: 80%;display: flex;flex-direction: column;box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.35);overflow: hidden;}
.header{width: 330px;height: 95px;padding: 10px; background-color: #21b9bf;
  .title{text-align: center;font-size: 24px;margin: 10px 0;color: #fff;}
  .methods{display: flex;padding:0;margin: 10px 0px;
    li{margin:0 px;border-radius: 50%;width: 55px;height: 55px;line-height: 55px;cursor:pointer;
      i{font-size: 35px;color: #fff;}
    }
  }
}
.context{flex: 1;background: rgba(10, 17, 43, 0.4); width: 100%;border-radius: 0 0 5px 5px;}
/deep/.inline-input{display: flex;align-items: center;}
/deep/.el-input__inner{border-radius: 20px;width: 250px;background: rgba(10, 17, 43, 0.4);border: solid 1px #3c818d;}
/deep/.el-input__suffix{width: 40px;line-height: 40px;font-size: 20px;cursor: pointer;}
/deep/.esri-ui-bottom-right{right: 356px !important;}
/deep/.esri-component{position: fixed;right: 20px;}
#toolbarDiv {top: 15px;right: 110px;cursor: default;display: flex;flex-direction: row;flex-wrap: nowrap;}
/deep/.esri-search{position: fixed;left: 395px;}
</style>

<template>
  <div class="box" v-loading="loading">
    <div id="sceneview"></div>
    <div class="search">
      <div class="heading">
        <h3 style="margin: 0;letter-spacing: 4px;">矿业信息地图</h3>
        <p style="margin:0">Mining Information Map</p>
      </div>
      <!-- 量算按钮-->
      <div id="toolbarDiv" class="esri-component esri-widget">
        <button id="distance" class="esri-widget--button esri-interactive esri-icon-measure-line" title="Distance Measurement Tool">
        </button>
        <button id="area" class="esri-widget--button esri-interactive esri-icon-measure-area" title="Area Measurement Tool">
        </button>
        <button id="clear" class="esri-widget--button esri-interactive esri-icon-trash" title="Clear Measurements">
        </button>
      </div>
    </div>
    <div class="menu">
      <div class="header">
        <div><i class="iconfont icon-more" style="font-size: 26px;font-weight: 700;color: #fff;cursor:pointer;" @click="onShrink"></i></div>
        <ul class="methods">
          <li v-for="(each, index) in listary" :key="index" class="list"><i :class="each.icon" :style="each.style" @click="onSelect(index)"></i></li>
        </ul>
      </div>
      <div class="context">
        <keep-alive>
          <component :is="selMenu.name"></component>
        </keep-alive>
      </div>
    </div>
  </div>
</template>
 
<script>
import { loadModules } from 'esri-loader'
import LayerManager from '../assembly/kyyzt/LayerManager'
let num = 1
export default {
  name: 'App',
  components: {LayerManager},
  data()
  {
    return {
      loading: true,
      listary: [],
      title: '',
      selIndex: null,
      state: ''
    }
  },
  computed:
  {
    selMenu()
    {
      return this.listary.find(item => item.name === this.selIndex)
    }
  },
  created()
  {
    window.esri = {}
    this.initMenu(0)
    this._createSceneView()
    //加载菜单
    this.$nextTick(() =>
    {
      this.onSelect(0)
      this.title = this.listary[0].title
    })
    //监听浏览器窗口变化
    window.addEventListener('resize', function()
    {
      let height = window.innerHeight
      let menu = document.querySelector('.menu')
      if (num % 2 === 1)
        menu.style.height = Math.ceil(height * 0.98) + 'px'
    })
  },
  methods:
  {
    //菜单展开收缩
    onShrink()
    {
      let menu = document.querySelector('.menu')
      let clientheight = menu.clientHeight
      if (num % 2 === 1)
      {
        let shrink = setInterval(() =>
        {
          clientheight -= 10
          menu.style.height = clientheight + 'px'
          if (clientheight <= 170)
            clearInterval(shrink)
        }, 10)
      }
      else
      {
        let open = setInterval(() =>
        {
          clientheight += 10
          menu.style.height = clientheight + 'px'
          if (clientheight >= Math.ceil(window.innerHeight * 0.98))
            clearInterval(open)
        }, 10)
      }
      num += 1
    },
    //选中当前button
    onSelect(index)
    {
      let list = document.querySelectorAll('.list')
      var alltableArray = Array.prototype.slice.call(list)
      alltableArray.forEach(e =>
      {
        e.style.background = 'none'
      })
      list[index].style.background = 'rgba(35,255,252,.4)'
      this.title = this.listary[index].title
      this.initMenu(index)
    },
    /**
     * 初始化参数对象。
     * @method
     */
    initMenu(index)
    {
      let menus =
      [
        {icon: 'iconfont icon-layers', title: '图层管理', name: 'LayerManager'},
        {icon: 'iconfont icon-mulu', title: '图例展示', name: 'Legend'},
        {icon: 'iconfont icon-chaxun', style: 'font-size: 33px;', title: '数据查询', name: ''},
        {icon: 'iconfont icon-celiang', title: '空间分析', name: ''}
      ]
      this.listary = menus
      this.selIndex = this.listary[index].name
    },
    //加载图层
    _createSceneView: function()
    {
      let self = this
      let options = {
        url: 'https://js.arcgis.com/4.21/',
        css: 'https://js.arcgis.com/4.21/esri/themes/light/main.css'
      }
      loadModules(
        [
          'esri/Map',
          'esri/views/MapView',
          'esri/tasks/Locator',
          'esri/layers/MapImageLayer',
          'esri/widgets/BasemapToggle',
          'esri/Basemap',
          'esri/widgets/Legend',
          'esri/layers/WebTileLayer',
          'esri/layers/support/TileInfo',
          'dojo/domReady!',
          //量算
          'esri/widgets/Measurement',
          //搜索
          'esri/widgets/Search'
        ], options).then(
        ([Map, MapView, Locator, MapImageLayer, BasemapToggle, Basemap, Legend, WebTileLayer, TileInfo, domReady, Measurement, Search]) =>
        {
          window.esri.MapImageLayer = MapImageLayer
          window.esri.Legend = Legend
          //加载天地图
          // const tileInfo = new TileInfo({
          //   dpi: 90.71428571427429,
          //   rows: 256,
          //   cols: 256,
          //   compressionQuality: 0,
          //   origin: {
          //     x: -180,
          //     y: 90
          //   },
          //   spatialReference: {
          //     wkid: 4326
          //   },
          //   lods: [
          //     { level: 2, levelValue: 2, resolution: 0.3515625, scale: 147748796.52937502 },
          //     { level: 3, levelValue: 3, resolution: 0.17578125, scale: 73874398.264687508 },
          //     { level: 4, levelValue: 4, resolution: 0.087890625, scale: 36937199.132343754 },
          //     { level: 5, levelValue: 5, resolution: 0.0439453125, scale: 18468599.566171877 },
          //     { level: 6, levelValue: 6, resolution: 0.02197265625, scale: 9234299.7830859385 },
          //     { level: 7, levelValue: 7, resolution: 0.010986328125, scale: 4617149.8915429693 },
          //     { level: 8, levelValue: 8, resolution: 0.0054931640625, scale: 2308574.9457714846 },
          //     { level: 9, levelValue: 9, resolution: 0.00274658203125, scale: 1154287.4728857423 },
          //     { level: 10, levelValue: 10, resolution: 0.001373291015625, scale: 577143.73644287116 },
          //     { level: 11, levelValue: 11, resolution: 0.0006866455078125, scale: 288571.86822143558 },
          //     { level: 12, levelValue: 12, resolution: 0.00034332275390625, scale: 144285.93411071779 },
          //     { level: 13, levelValue: 13, resolution: 0.000171661376953125, scale: 72142.967055358895 },
          //     { level: 14, levelValue: 14, resolution: 8.58306884765625e-005, scale: 36071.483527679447 },
          //     { level: 15, levelValue: 15, resolution: 4.291534423828125e-005, scale: 18035.741763839724 },
          //     { level: 16, levelValue: 16, resolution: 2.1457672119140625e-005, scale: 9017.8708819198619 },
          //     { level: 17, levelValue: 17, resolution: 1.0728836059570313e-005, scale: 4508.9354409599309 },
          //     { level: 18, levelValue: 18, resolution: 5.3644180297851563e-006, scale: 2254.4677204799655 },
          //     { level: 19, levelValue: 19, resolution: 2.68220901489257815e-006, scale: 1127.23386023998275 },
          //     { level: 20, levelValue: 2, resolution: 1.341104507446289075e-006, scale: 563.616930119991375 }
          //   ]
          // })
          // const layer2 = new WebTileLayer('http://{subDomain}.tianditu.com/DataServer?T=img_c&X={col}&Y={row}&L={level}&tk=6d86a8c13a0ab77225208716c06b9951', {
          //   // subDomains: ['t0','t1','t2','t3','t4','t5','t6','t7'],
          //   subDomains: ['t0'],
          //   tileInfo: tileInfo
          // })
          //创建图层
          // const basemap = new Basemap({
          //   baseLayers: [
          //     new WebTileLayer('http://{subDomain}.tianditu.gov.cn/vec_c/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=c&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=6d86a8c13a0ab77225208716c06b9951', {
          //       // subDomains: ['t0','t1','t2','t3','t4','t5','t6','t7'],
          //       subDomains: ['t0'],
          //       tileInfo: tileInfo
          //     })
          //   ],
          //   title: 'Terrain',
          //   id: 'terrain',
          //   thumbnailUrl: 'static/index/卫星图.png'
          // })
          //创建图层
          // const basemap1 = new Basemap({
          //   baseLayers: [
          //     new MapImageLayer({
          //       url: 'http://124.70.190.111:6080/arcgis/rest/services/kmdz/DZT/MapServer'
          //     })
          //   ]
          // })
          //创建图层
          const map = new Map({
            // basemap: {
            //   baseLayers: [layer2],
            //   thumbnailUrl: 'static/index/矢量图.png'
            // }
            basemap: 'hybrid'
          })
          //创建地图
          // const view = new MapView({
          //   container: 'sceneview', // Div element
          //   spatialReference: {
          //     wkid: 4326
          //   },
          //   map: map,
          //   center: [102.373, 5.216], // Longitude, latitude
          //   scale: 20000000
          // })
          const view = new MapView({
            container: 'sceneview',
            map: map,
            center: [107.178, 5.656],
            zoom: 5
          })
          window.view = view
          //创建图层切换工具
          const toggle = new BasemapToggle({
            view: view,
            nextBasemap: 'topo-vector'
          })
          view.ui.add(toggle, 'top-right')
          //地图加载完成
          view.when(function()
          {
            // layer2.when(function()
            // { //es6语法
            //   self.loading = false
            // })
            self.loading = false
          })
          //添加搜索
          const searchWidget = new Search({
            view: view
          })
          view.ui.add(searchWidget, {
            position: 'top-right'
          })
          // 点击查看属性
          const locatorTask = new Locator({
            url: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer'
          })
          //点击查看属性
          view.popup.autoOpenEnabled = false
          view.on('click', (event) =>
          {
          //获取单击视图时的坐标
            const lat = Math.round(event.mapPoint.latitude * 1000) / 1000
            const lon = Math.round(event.mapPoint.longitude * 1000) / 1000
            view.popup.open({
            // 将弹出窗口的标题设置为位置的坐标
              title: 'Reverse geocode: [' + lon + ', ' + lat + ']',
              location: event.mapPoint // 将弹出窗口的位置设置为单击的位置
            })
            const params = {
              location: event.mapPoint
            }
            // 显示弹出窗口
            // 使用单击的位置执行反向地理代码
            locatorTask
              .locationToAddress(params)
              .then((response) =>
              {
              // 如果成功找到地址，请在弹出窗口的内容中显示该地址
                view.popup.content = response.address
              })
              .catch(() =>
              {
              // 如果承诺失败且未找到结果，则显示一般消息
                view.popup.content = 'No address was found for this location'
              })
          })
          /**距离量算面积量算 */
          // 将activeView设置为二维地图视图
          let activeView = view
          // 创建度量小部件的新实例
          const measurement = new Measurement()
          //为按钮设置事件处理程序并单击事件
          const distanceButton = document.getElementById('distance')
          const areaButton = document.getElementById('area')
          const clearButton = document.getElementById('clear')
          distanceButton.addEventListener('click', () =>
          {
            distanceMeasurement()
          })
          areaButton.addEventListener('click', () =>
          {
            areaMeasurement()
          })
          clearButton.addEventListener('click', () =>
          {
            clearMeasurements()
          })
          // 为初始视图调用loadView（）函数
          loadView()
          // 函数的作用是：定义小部件和div的视图
          function loadView()
          {
          // 激活时，将适当的测量UI添加到右下角
            activeView.ui.add(measurement, 'bottom-right')
            // 设置小部件的视图
            measurement.view = activeView
          }
          //调用适当的distemeasurement2d或DirectLineMeasurement3D
          function distanceMeasurement()
          {
            const type = activeView.type
            measurement.activeTool = type.toUpperCase() === '2D' ? 'distance' : 'direct-line'
            distanceButton.classList.add('active')
            areaButton.classList.remove('active')
          }
          // 调用适当的AreaMeasurement2D或AreaMeasurement3D
          function areaMeasurement()
          {
            measurement.activeTool = 'area'
            distanceButton.classList.remove('active')
            areaButton.classList.add('active')
          }
          // 清除所有测量
          function clearMeasurements()
          {
            distanceButton.classList.remove('active')
            areaButton.classList.remove('active')
            measurement.clear()
          }
        }
      )
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/project/Kyyzt.vue